import { render, staticRenderFns } from "./UiFab.vue?vue&type=template&id=003e3791"
import script from "./UiFab.vue?vue&type=script&lang=js"
export * from "./UiFab.vue?vue&type=script&lang=js"
import style0 from "./UiFab.vue?vue&type=style&index=0&id=003e3791&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports